var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"pi-tabs",attrs:{"aria-label":"Visões do Product Intelligence"}},_vm._l((_vm.views),function(view){return _c('router-link',{key:view.key,staticClass:"pi-tab",class:{ 'is-on': _vm.current === view.key },attrs:{"to":{ path: view.path, query: _vm.query },"aria-current":_vm.current === view.key ? 'page' : null}},[_vm._v(_vm._s(view.label))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25eb985c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/pi/piTabs.vue
// module id = 1598
// module chunks = 0